import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../../../app/services/auth.service';
import { GigyaSessionService } from '../../../app/services/gigya-session.service';
import { Router, ActivatedRoute } from '@angular/router';
import { appSetting } from "../../../../config/appSettings";
import { MessageService, MessageEmitData } from '../../services/message.service';
import {Subscription} from "rxjs";
import { AppHelperService } from '../../../app/services/app-helper.service';
import { configService } from "libs-frontend-micro-base";
declare var NotificationsLib: any;

@Component({
    selector: 'common-header',
    styleUrls: ['./common-header.style.scss'],
    templateUrl: './common-header.template.html',
    standalone: false
})
export class CommonHeader implements OnInit, AfterViewInit{
  userProfileData:any;
  @Input() customHeader: boolean = false;
  @Input() isSCompContent: boolean = false;
  @Output() onLogout = new EventEmitter<string>();
  @ViewChild('tutorialDropdownBtnRef', { static: false }) tutorialDropdownBtnRef: ElementRef;
  @ViewChild('tutorialOptionsRef', { static: false }) tutorialOptionsRef: ElementRef;
  public previewMode = false;
  public adminSelectedView: boolean;
  userData: any;
  isDisableCUPLogo:boolean = false;
  ltiDeepLinkingMode : boolean = false;
  public imageBasePath: string = IMAGES_BASEPATH;
  private messageServiceSubs: Subscription;
  private patterns = [
    {
      pattern: new RegExp(/assignments\/product/),
      channel: "assignment-detail",
    },
    {
      pattern: new RegExp(/\/edit-assignment\//),
      channel: "assignment-detail"
    }
  ];

  public tutorialLinksMap = {
    'UNDERSTANDING_CODES_AND_KEYS': 'understandingCodesAndKeys',
    'ACTIVATING_COURSE_MATERIALS': 'activatingCourseMaterials',
    'CREATING_A_CLASS': 'creatingClass',
    'ADDING_STUDENTS_TO_A_CLASS': 'addingStudentsToClass',
    'CREATING_ASSIGNMENTS': 'creatingAssignments'
  };
  public tutorialKeys = Object.keys(this.tutorialLinksMap);
  
  constructor(
    private authService : AuthService, 
    private gigyaSessionService : GigyaSessionService,
    private router: Router,
    private route: ActivatedRoute,
    public appHelperService : AppHelperService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.userData = this.authService.getUserData();
    if(!this.userData && this.router.url.indexOf('?preview=true') === -1) { // Do not send to /home in case of builder preview URL
      this.appHelperService.navigateToOnboardingApp(['home'], { forceExit: true });
      return;
    }
    
    this.fetchFreshData(); 

    // Get the value from localstorage the current toggle value for admin is "admin/teacher", if not builder preview URL
    if(this.router.url.indexOf('?preview=true') === -1) {
      let key = appSetting.localStorage.adminSelectedView + this.userData.extUserId;
      this.adminSelectedView = localStorage.getItem(key) === "admin";
    }
    this.ltiDeepLinkingMode = this.router.url && this.router.url.indexOf("/ltideeplinking/") !== -1;
    this.isDisableCUPLogo = this.userData && this.userData.launchType == 'lti' && ['ltd', 'ltc'].indexOf(this.route.snapshot.queryParams.lf) === -1 && !this.ltiDeepLinkingMode;

    this.messageServiceSubs = this.messageService
      .getChannelObservable("header")
      .subscribe((res: MessageEmitData) => {
        if (res.data.functionName) {
          const args = res.data.navigatingMicroApps;
          this[res.data.functionName](args);
        }
      });
  }

  ngAfterViewInit() {
    if(!this.previewMode && !this.isSCompContent)
      this.notificationComponentEventHandler();
  }

  ngOnDestroy(): void {
    this.messageServiceSubs.unsubscribe();
  }

  public fetchFreshData(){
    if(this.router.url.indexOf('?preview=true') !== -1) {
      this.previewMode = true;
    } else {
      this.previewMode = false;
      window['gigya'] ? handleGigyaAvailable.apply(this) : this.gigyaSessionService.getGigyaLoadListener().subscribe(()=>{ handleGigyaAvailable.apply(this) });  
    }
    async function handleGigyaAvailable(){
      let res = await this.gigyaSessionService.getUserData();
      if(!res) {
        return this.appHelperService.navigateToOnboardingApp(['home'], { forceExit: true });
      } 
      this.userProfileData = res.profile;
      this.userProfileData['role'] = res.c1UserRole;
    }
  }
  
  public navigateToClass(force = false) {
    const { params } = this.route.snapshot;
    if (force) {
      this.appHelperService.navigateToClassApp(['teacher', params.spaceid, 'class', params.cid, 'create', 'assignments']);
    }
  }

  public navigateToDashboard() {
    const routerOptions = {
      state: {
        navigationTrigger: 'cup-logo'
      }
    };

    if (!this.onLinkClick('navigateToClass', true, routerOptions)) {
      return;
    }

    const { queryParams, params } = this.route.snapshot;
    if(queryParams.lf == 'ltd' || this.ltiDeepLinkingMode) {
      this.appHelperService.navigateToOnboardingApp(['lti-teacher-dashboard', params.spaceid, 'class', queryParams.cid || params.classid, 'ltik', queryParams.ltik], routerOptions);
    } else if(queryParams.lf == 'ltc') {
      this.appHelperService.navigateToOnboardingApp(['lti-component-selection', params.spaceid, 'class', queryParams.cid, 'bundle', queryParams.bcode, 'resource', queryParams.rcode, 'ltik', queryParams.ltik], routerOptions);
    } else {
      this.appHelperService.showLoaderAndNavigateToDashboard(this.userData, routerOptions);
    }
  }

  public logOut() {
    if(this.onLogout.observers.length>0){
      this.onLogout.emit('');
      return;
    }

    // Auth Service Logout
    this.authService.logOut().toPromise().then(
      (res) => {
        if (res.success) {
          this.authService.clearUserdata();
          // Gigya Service Logout
          return this.gigyaSessionService.gigyaLogout();
        }
      }
    ).then(() => {
      // On Logout navigate to home page
      this.appHelperService.navigateToOnboardingApp(['home']);
    });
  }

  public navigatetoMyProfile() {
    this.appHelperService.navigateToDashboardApp(['my-profile']);
  }
   
  private notificationComponentEventHandler() {
    if (typeof NotificationsLib !== 'undefined') {
      this.initialiseNotificationComponent();
    } else {
      //Listen to notification custom event
      const handler = () => {
        this.initialiseNotificationComponent();
        window.removeEventListener('cambridgeOne.notificationComponentLoaded', handler);
      };
      window.addEventListener('cambridgeOne.notificationComponentLoaded', handler);
    }
  }

  private initialiseNotificationComponent() {
    setTimeout(() => {
      const notificationsLib = new NotificationsLib.NotificationsComponent();
      notificationsLib.init('notificationContainer');
    }, 0)
  }

  private onLinkClick(functionName, navigatingMicroApps = false, options: any = {}) {
    const patternObject = this.findPattern(window.location.href);
    if (patternObject) {
      this.messageService.emit(patternObject.channel, {
        navigatingMicroApps,
        functionName,
        options
      });
      return false;
    }
    return true;
  }

  private findPattern(url: string) {
    for (const patternObject of this.patterns) {
      if (patternObject.pattern.test(url)) {
        return patternObject;
      }
    }
    return null;
  }

  gotoHelpPage() {
    window.open(configService.getHelpPagePath(APP_ENV, '', '', localStorage.getItem(appSetting.localStorage.lang)), "_blank");
  }

  /**
   * Handles the click event on the help dropdown button and hides the tutorials menu
   */
  public handleHelpBtnClick = () => {
    this.handleHideTutorialsMenu();
  };

  /**
   * Redirects to the tutorial help links page and hide the tutorials dropdown menu
   */
  public goToTutorialHelpLinksPage = (article) => {
    // hide the tutorials menu
    this.handleHideTutorialsMenu();
    // navigate to the tutorial help links page
    window.open(
      configService.getHelpPagePath(APP_ENV, 'teacher', article),
      '_blank'
    );
  };

  /**
   * Triggered when mouse enters the tutorials dropdown button
   * Case 1: If the device is desktop or tablet, show the tutorials menu
   * Case 2: If the device is mobile, do nothing
   */
  public handleMouseEnter = () => {
    if (window.innerWidth >= 768) {
      this.handleShowTutorialsMenu();
    }
  };

  /**
   * Triggered when mouse leaves the tutorials dropdown button for all screens/devices
   */
  public handleMouseLeave = () => {
    this.handleHideTutorialsMenu();
  };

  /**
   * Shows the tutorials menu by adding 'show' class to the tutorial options
   * Also adds 'tutorial-dropdown-open' class to the tutorial dropdown button which is used to show up and down icons
   */
  public handleShowTutorialsMenu = () => {
    this.tutorialDropdownBtnRef.nativeElement?.classList.add('tutorial-dropdown-open');
    this.tutorialOptionsRef.nativeElement?.classList.add('show');
  };

  /**
   * Hides the tutorials menu by removing 'show' class from the tutorial options
   * Removes 'tutorial-dropdown-open' class from the tutorial dropdown button
   */
  public handleHideTutorialsMenu = () => {
    this.tutorialDropdownBtnRef.nativeElement?.classList.remove('tutorial-dropdown-open');
    this.tutorialOptionsRef.nativeElement?.classList.remove('show');
  };

  /**
   * Case 1: If the device is mobile, toggle the tutorials dropdown menu
   * Case 2: If the device is desktop or tablet, show the tutorials dropdown menu only(does not toggle)
   */
  public handleToggleTutorialsMenu = (e) => {
    e.stopPropagation();
    if (
      !this.tutorialOptionsRef.nativeElement?.classList.contains('show') ||
      window.innerWidth >= 768
    ) {
      this.handleShowTutorialsMenu();
    } else {
      this.handleHideTutorialsMenu();
    }
  };
}